import { Component } from 'react';

export default class QuantityContainer extends Component {
  state = {
    quantity: 1
  };

  setQuantity = qty => {
    // Ensure negative numbers can't be added
    const quantity = qty > 0 ? qty : 1;
    this.setState({ quantity });
  };

  render() {
    return this.props.children({
      quantity: this.state.quantity,
      setQuantity: this.setQuantity
    });
  }
}
